import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-hbar-event-counts-per-entity',
  templateUrl: './hbar-event-counts-per-entity.component.html',
  styleUrl: './hbar-event-counts-per-entity.component.scss',
})
export class HbarEventCountsPerEntityComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.hbarEventCountsPerEntity$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('hbarEventCountsPerEntity');
    });

    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getHbarEventCountsPerEntity().subscribe();
  }

  get data() {
    return this.analyticsService.hbarEventCountsPerEntity$.value;
  }
}
